/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccountWebhookDelivery,
  AccountWebhookResponse,
  AccountWebhookWithSecret,
  CreateAccountWebhookBody,
  DeleteAccountWebhook200,
  Error,
  GetAccountWebhookDeliveries200,
  GetAccountWebhookDeliveriesParams,
  GetAccountWebhooks200,
  GetAccountWebhooksParams,
  UpdateAccountWebhookBody,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * @summary Create a new account webhook
 */
export type createAccountWebhookResponse201 = {
  data: AccountWebhookWithSecret
  status: 201
}

export type createAccountWebhookResponse400 = {
  data: Error
  status: 400
}

export type createAccountWebhookResponse401 = {
  data: Error
  status: 401
}

export type createAccountWebhookResponse403 = {
  data: Error
  status: 403
}

export type createAccountWebhookResponse404 = {
  data: Error
  status: 404
}

export type createAccountWebhookResponse422 = {
  data: ValidationError
  status: 422
}

export type createAccountWebhookResponse500 = {
  data: Error
  status: 500
}

export type createAccountWebhookResponseSuccess = (createAccountWebhookResponse201) & {
  headers: Headers;
};
export type createAccountWebhookResponseError = (createAccountWebhookResponse400 | createAccountWebhookResponse401 | createAccountWebhookResponse403 | createAccountWebhookResponse404 | createAccountWebhookResponse422 | createAccountWebhookResponse500) & {
  headers: Headers;
};

export type createAccountWebhookResponse = (createAccountWebhookResponseSuccess | createAccountWebhookResponseError)

export const getCreateAccountWebhookUrl = () => {


  

  return `/account-webhooks`
}

export const createAccountWebhook = async (createAccountWebhookBody: CreateAccountWebhookBody, options?: RequestInit): Promise<createAccountWebhookResponse> => {
  
  return customFetch<createAccountWebhookResponse>(getCreateAccountWebhookUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createAccountWebhookBody,)
  }
);}
  

/**
 * @summary List all account webhooks
 */
export type getAccountWebhooksResponse200 = {
  data: GetAccountWebhooks200
  status: 200
}

export type getAccountWebhooksResponse400 = {
  data: Error
  status: 400
}

export type getAccountWebhooksResponse401 = {
  data: Error
  status: 401
}

export type getAccountWebhooksResponse403 = {
  data: Error
  status: 403
}

export type getAccountWebhooksResponse404 = {
  data: Error
  status: 404
}

export type getAccountWebhooksResponse500 = {
  data: Error
  status: 500
}

export type getAccountWebhooksResponseSuccess = (getAccountWebhooksResponse200) & {
  headers: Headers;
};
export type getAccountWebhooksResponseError = (getAccountWebhooksResponse400 | getAccountWebhooksResponse401 | getAccountWebhooksResponse403 | getAccountWebhooksResponse404 | getAccountWebhooksResponse500) & {
  headers: Headers;
};

export type getAccountWebhooksResponse = (getAccountWebhooksResponseSuccess | getAccountWebhooksResponseError)

export const getGetAccountWebhooksUrl = (params?: GetAccountWebhooksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/account-webhooks?${stringifiedParams}` : `/account-webhooks`
}

export const getAccountWebhooks = async (params?: GetAccountWebhooksParams, options?: RequestInit): Promise<getAccountWebhooksResponse> => {
  
  return customFetch<getAccountWebhooksResponse>(getGetAccountWebhooksUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Get an account webhook by ID
 */
export type getAccountWebhookByIdResponse200 = {
  data: AccountWebhookResponse
  status: 200
}

export type getAccountWebhookByIdResponse401 = {
  data: Error
  status: 401
}

export type getAccountWebhookByIdResponse403 = {
  data: Error
  status: 403
}

export type getAccountWebhookByIdResponse404 = {
  data: Error
  status: 404
}

export type getAccountWebhookByIdResponse500 = {
  data: Error
  status: 500
}

export type getAccountWebhookByIdResponseSuccess = (getAccountWebhookByIdResponse200) & {
  headers: Headers;
};
export type getAccountWebhookByIdResponseError = (getAccountWebhookByIdResponse401 | getAccountWebhookByIdResponse403 | getAccountWebhookByIdResponse404 | getAccountWebhookByIdResponse500) & {
  headers: Headers;
};

export type getAccountWebhookByIdResponse = (getAccountWebhookByIdResponseSuccess | getAccountWebhookByIdResponseError)

export const getGetAccountWebhookByIdUrl = (id: string,) => {


  

  return `/account-webhooks/${id}`
}

export const getAccountWebhookById = async (id: string, options?: RequestInit): Promise<getAccountWebhookByIdResponse> => {
  
  return customFetch<getAccountWebhookByIdResponse>(getGetAccountWebhookByIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Update an account webhook
 */
export type updateAccountWebhookResponse200 = {
  data: AccountWebhookResponse
  status: 200
}

export type updateAccountWebhookResponse400 = {
  data: Error
  status: 400
}

export type updateAccountWebhookResponse401 = {
  data: Error
  status: 401
}

export type updateAccountWebhookResponse403 = {
  data: Error
  status: 403
}

export type updateAccountWebhookResponse404 = {
  data: Error
  status: 404
}

export type updateAccountWebhookResponse422 = {
  data: ValidationError
  status: 422
}

export type updateAccountWebhookResponse500 = {
  data: Error
  status: 500
}

export type updateAccountWebhookResponseSuccess = (updateAccountWebhookResponse200) & {
  headers: Headers;
};
export type updateAccountWebhookResponseError = (updateAccountWebhookResponse400 | updateAccountWebhookResponse401 | updateAccountWebhookResponse403 | updateAccountWebhookResponse404 | updateAccountWebhookResponse422 | updateAccountWebhookResponse500) & {
  headers: Headers;
};

export type updateAccountWebhookResponse = (updateAccountWebhookResponseSuccess | updateAccountWebhookResponseError)

export const getUpdateAccountWebhookUrl = (id: string,) => {


  

  return `/account-webhooks/${id}`
}

export const updateAccountWebhook = async (id: string,
    updateAccountWebhookBody: UpdateAccountWebhookBody, options?: RequestInit): Promise<updateAccountWebhookResponse> => {
  
  return customFetch<updateAccountWebhookResponse>(getUpdateAccountWebhookUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAccountWebhookBody,)
  }
);}
  

/**
 * @summary Delete an account webhook
 */
export type deleteAccountWebhookResponse200 = {
  data: DeleteAccountWebhook200
  status: 200
}

export type deleteAccountWebhookResponse400 = {
  data: Error
  status: 400
}

export type deleteAccountWebhookResponse401 = {
  data: Error
  status: 401
}

export type deleteAccountWebhookResponse403 = {
  data: Error
  status: 403
}

export type deleteAccountWebhookResponse404 = {
  data: Error
  status: 404
}

export type deleteAccountWebhookResponse422 = {
  data: ValidationError
  status: 422
}

export type deleteAccountWebhookResponse500 = {
  data: Error
  status: 500
}

export type deleteAccountWebhookResponseSuccess = (deleteAccountWebhookResponse200) & {
  headers: Headers;
};
export type deleteAccountWebhookResponseError = (deleteAccountWebhookResponse400 | deleteAccountWebhookResponse401 | deleteAccountWebhookResponse403 | deleteAccountWebhookResponse404 | deleteAccountWebhookResponse422 | deleteAccountWebhookResponse500) & {
  headers: Headers;
};

export type deleteAccountWebhookResponse = (deleteAccountWebhookResponseSuccess | deleteAccountWebhookResponseError)

export const getDeleteAccountWebhookUrl = (id: string,) => {


  

  return `/account-webhooks/${id}`
}

export const deleteAccountWebhook = async (id: string, options?: RequestInit): Promise<deleteAccountWebhookResponse> => {
  
  return customFetch<deleteAccountWebhookResponse>(getDeleteAccountWebhookUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * @summary Test an account webhook
 */
export type testAccountWebhookResponse200 = {
  data: AccountWebhookDelivery
  status: 200
}

export type testAccountWebhookResponse400 = {
  data: Error
  status: 400
}

export type testAccountWebhookResponse401 = {
  data: Error
  status: 401
}

export type testAccountWebhookResponse403 = {
  data: Error
  status: 403
}

export type testAccountWebhookResponse404 = {
  data: Error
  status: 404
}

export type testAccountWebhookResponse422 = {
  data: ValidationError
  status: 422
}

export type testAccountWebhookResponse500 = {
  data: Error
  status: 500
}

export type testAccountWebhookResponseSuccess = (testAccountWebhookResponse200) & {
  headers: Headers;
};
export type testAccountWebhookResponseError = (testAccountWebhookResponse400 | testAccountWebhookResponse401 | testAccountWebhookResponse403 | testAccountWebhookResponse404 | testAccountWebhookResponse422 | testAccountWebhookResponse500) & {
  headers: Headers;
};

export type testAccountWebhookResponse = (testAccountWebhookResponseSuccess | testAccountWebhookResponseError)

export const getTestAccountWebhookUrl = (id: string,) => {


  

  return `/account-webhooks/${id}/test`
}

export const testAccountWebhook = async (id: string, options?: RequestInit): Promise<testAccountWebhookResponse> => {
  
  return customFetch<testAccountWebhookResponse>(getTestAccountWebhookUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * @summary List account webhook deliveries
 */
export type getAccountWebhookDeliveriesResponse200 = {
  data: GetAccountWebhookDeliveries200
  status: 200
}

export type getAccountWebhookDeliveriesResponse400 = {
  data: Error
  status: 400
}

export type getAccountWebhookDeliveriesResponse401 = {
  data: Error
  status: 401
}

export type getAccountWebhookDeliveriesResponse403 = {
  data: Error
  status: 403
}

export type getAccountWebhookDeliveriesResponse404 = {
  data: Error
  status: 404
}

export type getAccountWebhookDeliveriesResponse500 = {
  data: Error
  status: 500
}

export type getAccountWebhookDeliveriesResponseSuccess = (getAccountWebhookDeliveriesResponse200) & {
  headers: Headers;
};
export type getAccountWebhookDeliveriesResponseError = (getAccountWebhookDeliveriesResponse400 | getAccountWebhookDeliveriesResponse401 | getAccountWebhookDeliveriesResponse403 | getAccountWebhookDeliveriesResponse404 | getAccountWebhookDeliveriesResponse500) & {
  headers: Headers;
};

export type getAccountWebhookDeliveriesResponse = (getAccountWebhookDeliveriesResponseSuccess | getAccountWebhookDeliveriesResponseError)

export const getGetAccountWebhookDeliveriesUrl = (id: string,
    params?: GetAccountWebhookDeliveriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/account-webhooks/${id}/deliveries?${stringifiedParams}` : `/account-webhooks/${id}/deliveries`
}

export const getAccountWebhookDeliveries = async (id: string,
    params?: GetAccountWebhookDeliveriesParams, options?: RequestInit): Promise<getAccountWebhookDeliveriesResponse> => {
  
  return customFetch<getAccountWebhookDeliveriesResponse>(getGetAccountWebhookDeliveriesUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Rotate account webhook secret
 */
export type rotateAccountWebhookSecretResponse200 = {
  data: AccountWebhookWithSecret
  status: 200
}

export type rotateAccountWebhookSecretResponse400 = {
  data: Error
  status: 400
}

export type rotateAccountWebhookSecretResponse401 = {
  data: Error
  status: 401
}

export type rotateAccountWebhookSecretResponse403 = {
  data: Error
  status: 403
}

export type rotateAccountWebhookSecretResponse404 = {
  data: Error
  status: 404
}

export type rotateAccountWebhookSecretResponse422 = {
  data: ValidationError
  status: 422
}

export type rotateAccountWebhookSecretResponse500 = {
  data: Error
  status: 500
}

export type rotateAccountWebhookSecretResponseSuccess = (rotateAccountWebhookSecretResponse200) & {
  headers: Headers;
};
export type rotateAccountWebhookSecretResponseError = (rotateAccountWebhookSecretResponse400 | rotateAccountWebhookSecretResponse401 | rotateAccountWebhookSecretResponse403 | rotateAccountWebhookSecretResponse404 | rotateAccountWebhookSecretResponse422 | rotateAccountWebhookSecretResponse500) & {
  headers: Headers;
};

export type rotateAccountWebhookSecretResponse = (rotateAccountWebhookSecretResponseSuccess | rotateAccountWebhookSecretResponseError)

export const getRotateAccountWebhookSecretUrl = (id: string,) => {


  

  return `/account-webhooks/${id}/rotate-secret`
}

export const rotateAccountWebhookSecret = async (id: string, options?: RequestInit): Promise<rotateAccountWebhookSecretResponse> => {
  
  return customFetch<rotateAccountWebhookSecretResponse>(getRotateAccountWebhookSecretUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

